// @flow

import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';

import Link from 'app/common/components/Link';
import LoginActions from 'app/login/LoginActions';
import LoginDifferent from 'app/login/components/LoginDifferent';
import LoginForm from 'app/login/components/LoginForm';
import MaybeLoad from 'app/common/components/MaybeLoad';
import TrackActions from 'app/track/TrackActions';
import hocify from 'app/common/components/hocify';

const Description = () => (
  <div>
    <p>
      <strong>Hold up!</strong> It looks like multiple people or devices have
      been using your Zapier account.
    </p>
    <p>
      To keep your account secure, we recommend that you don’t share your login.{' '}
      If you are sharing your account with other people, try using{' '}
      <Link href="/settings/plans">Zapier for Teams</Link> to improve your
      team’s security and prevent this message from popping up in the future.
    </p>
    <p>
      Not sure why you’re seeing this message? <br />
      <a href="/app/contact-us">Contact our support team</a>
    </p>
  </div>
);

const mapStateToProps = state => {
  const page = state.login.secureSessionAuthPage;
  const next = state.router.current.query.next;

  const canSubmit = !page.isSubmitting;
  return {
    title: 'Secure Session',
    submitText: 'Confirm this Session',
    canSubmit,
    // didSucceed: page.result == 'success', // or similar?
    isSubmitting: page.isSubmitting,
    fields: [], // no fields needed here yet
    description: <Description />,
    footer: <LoginDifferent next={next} />,
    next,
    shouldShowLoginForm: true,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    onLoad: () => {
      dispatch(TrackActions.track('Teams: display multiple session upsell'));
    },
    onSubmit: (fields, next) => {
      dispatch(TrackActions.track('Teams: submit multiple session upsell'));
      dispatch(LoginActions.confirmSecureSession(next));
    },
  };
};

const ConfirmSecureSessionContainer = _.flowRight(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  hocify(MaybeLoad)
)(LoginForm);

export default ConfirmSecureSessionContainer;
